import React, { useEffect, useState } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { useSelector } from "react-redux";
import axios from "axios";
import { red } from "@mui/material/colors";
import { isNetworkError } from "helpers/isNetworkError";

const DATAAPP_URL = process.env.REACT_APP_RAPID_CANVAS_DATAAPP_URL;
const TOKEN_ENDPOINT = `${process.env.REACT_APP_RAPID_CANVAS_URL}/access_key/token`;
const API_KEY = process.env.REACT_APP_RAPID_CANVAS_API_KEY;

const fetchToken = async (extUserId) => {
  const { data } = await axios.post(
    TOKEN_ENDPOINT,
    { extUserId },
    { headers: { "X-API-KEY": API_KEY, "Content-Type": "application/json" } }
  );
  return data.token;
};

const getTokenErrorMessage = (error) => {
  if (isNetworkError(error)) {
    return "No se pudo conectar con RapidCanvas (error de red/CORS). Verifica tu conexión o contacta al administrador.";
  }
  if (error?.response?.status === 401 || error?.response?.status === 403) {
    return "API Key de RapidCanvas inválida o expirada. Contacta al administrador.";
  }
  return "Error al obtener token de RapidCanvas. Intente recargar la página.";
};

export const ReportRapidCanvasView = () => {
  const { username } = useSelector((state) => state.login);
  const [iframeSrc, setIframeSrc] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchToken(username)
      .then((token) => {
        const separator = DATAAPP_URL.includes("?") ? "&" : "?";
        setIframeSrc(`${DATAAPP_URL}${separator}token=${token}`);
      })
      .catch((err) => {
        console.error("RapidCanvas token error:", err);
        setError(getTokenErrorMessage(err));
      });
  }, [username]);

  if (error) {
    return (
      <GlobalBox title="Dashboard Distribución" icon={<DashboardIcon />}>
        <p style={{ textAlign: "center", padding: 40, color: red[700] }}>
          {error}
        </p>
      </GlobalBox>
    );
  }

  if (!iframeSrc) {
    return (
      <GlobalBox title="Dashboard Distribución" icon={<DashboardIcon />}>
        <LoadingComponent label="Cargando dashboard..." />
      </GlobalBox>
    );
  }

  return (
    <GlobalBox
      title="Dashboard Distribución"
      icon={<DashboardIcon />}
      styleBody={{ padding: 0 }}
    >
      <iframe
        src={iframeSrc}
        width="100%"
        height="800"
        frameBorder="0"
        allow="fullscreen"
        title="RapidCanvas Dashboard"
        style={{ border: "none", borderRadius: 4 }}
      />
    </GlobalBox>
  );
};
